import { useEffect } from 'react'
import { applySeo, applyStructuredData, SeoConfig } from '../utils/seo'

/**
 * Applies invisible page metadata and optional JSON-LD structured data.
 * Rendering is untouched — this only writes into document.head.
 */
export function useSeo(config: SeoConfig, structuredData?: unknown): void {
  useEffect(() => {
    applySeo(config)
    if (structuredData) {
      applyStructuredData('page', structuredData)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [config.title, config.description, config.path])
}
